import { isArray } from 'util';
import { WorkingShift } from '../calendar/working-shift';

export class WorkingShiftBuilder {
  static fromJson(json) {
    return (json)
      ? new WorkingShift(
        json.hash,
        json.name,
        json.hasBreak,
        json.breakTime,
        json.workingShiftDateRanges
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(WorkingShiftBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/working-shift.builder.ts